/* React components */
import { useState } from "react";
/* Custom hooks */
import { validateProblem, validateFile, validateAsunto } from "./uthValidation";

/* Import for ResetForm */
import React, { StrictMode } from "react";
import ReactDOM from "react-dom";

//Formularios
import Form from "../Form";
import "../css/stylesUTH.css";

const isEmpty = (obj) => Object.keys(obj).length === 0;

const useUth = ({
  initialValues,
  validationSchema,
  validate,
  validateOnChange = true,
  validateAllFields = false,
  onSubmit,
}) => {
  const [values, setValues] = useState(initialValues),
    [errors, setErrors] = useState({}),
    getRulesSchema = validationSchema ? Object.values(validationSchema) : [],
    getPropertiesNameSchema = validationSchema
      ? Object.getOwnPropertyNames(validationSchema)
      : [],
    getPropertiesValues = Object.getOwnPropertyNames(initialValues),
    runValidationRules = (property, value) => {
      let result;
      if (validationSchema[property].isEmail) {
        const existMaxRule = validationSchema[property].max;
        const max = existMaxRule && existMaxRule.limit;
        result = validateFile({
          value,
          required: validationSchema[property].required,
          max,
          validEmail: validationSchema[property].validEmail,
          validArea: validationSchema[property].validArea,
          shortValue:
            existMaxRule &&
            (typeof existMaxRule.message === "function"
              ? existMaxRule.message(max)
              : existMaxRule.message),
        });
      } else if (validationSchema[property].isAsunto){
        const existMinRule = validationSchema[property].min;
        const existMaxRule = validationSchema[property].max;
        const max = existMaxRule && existMaxRule.limit;
        const min = existMinRule && existMinRule.limit;
        result = validateAsunto({
          value,
          required: validationSchema[property].required,
          min,
          max,
          validAsunto: validationSchema[property].validAsunto,
          shortValue:
            existMinRule &&
            (typeof existMinRule.message === "function"
              ? existMinRule.message(min)
              : existMinRule.message),
          maxValue:
            existMaxRule &&
            (typeof existMaxRule.message === "function"
              ? existMaxRule.message(max)
              : existMaxRule.message),
        });
      } else {
        const existMinRule = validationSchema[property].min;
        const existMaxRule = validationSchema[property].max;
        const max = existMaxRule && existMaxRule.limit;
        const min = existMinRule && existMinRule.limit;
        result = validateProblem({
          problema: property,
          value,
          required: validationSchema[property].required,
          min,
          max,
          shortValue:
            existMinRule &&
            (typeof existMinRule.message === "function"
              ? existMinRule.message(min)
              : existMinRule.message),
          maxValue:
            existMaxRule &&
            (typeof existMaxRule.message === "function"
              ? existMaxRule.message(max)
              : existMaxRule.message),
        });
      }

      return result;
    },
    runValidationSchema = (result) => {
      setErrors(result);
      isEmpty(result) &&
        onSubmit({
          values,
          resetForm,
        });
    },
    deleteUndefinedErrors = (result, property) => {
      if (isEmpty(result)) {
        const deleteProperty = { ...errors };
        delete deleteProperty[property];
        !isEmpty(errors) && setErrors(deleteProperty);
      } else {
        setErrors({ ...errors, [property]: result[property] });
      }
    },
    runValidationErrors = ({ property, value, allValues }) => {
      const getErrors = validateAllFields
        ? validate(allValues)
        : validate(property, value);
      return getErrors;
    },
    runValidateAllFields = () => {
      let result;
      if (validationSchema) {
        result = getRulesSchema.reduce((acc, _, i) => {
          const property = getPropertiesNameSchema[i];
          const getValidationResult = runValidationRules(
            property,
            values[property]
          );
          return { ...acc, ...getValidationResult };
        }, {});
      } else if (validate) {
        result = getPropertiesValues.reduce((acc, property) => {
          const getErrors = runValidationErrors({
            property,
            value: values[property],
            allValues: values,
          });
          return { ...acc, ...getErrors };
        }, {});
      }
      runValidationSchema(result);
    },
    setFieldValue = (property, value) => {
      let deleteErrors;
      const fieldValue = { ...values, [property]: value };
      setValues(fieldValue);
      if (validateOnChange) {
        if (validationSchema) {
          deleteErrors = runValidationRules(property, value);
        } else if (validate) {
          const getErrors = runValidationErrors({
            property,
            value,
            allValues: fieldValue,
          });
          deleteErrors = getErrors;
          typeof getErrors === "object" && setErrors(getErrors);
        }
      }
      deleteUndefinedErrors(deleteErrors, property);
    },
    resetForm = () => {
      const main = document.getElementsByTagName("main")[0];
      ReactDOM.render(
        <StrictMode>
          <Form />
        </StrictMode>,
        main
      );
      setErrors({});
    },
    newTicket = () => {
      setValues(initialValues);
      document.getElementById("file").value = "";
      document.getElementById("campus").value = "";
      document.getElementById("asunto").value = "";
      setErrors({});
      document.getElementById("problem").className = "form-control";
      document.getElementById("submitButton").disabled = true;
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente";
    };

  return {
    values,
    setFieldValue,
    errors,
    resetForm,
    newTicket,
  };
};

export default useUth;
